/**
 * The chapter each act of the retreat opens with.
 *
 * This was the only copy of it. It is now the fallback: the chapters live on
 * the retreat (`retreat_acts`) and arrive with the journey, so the whole story
 * can be written from the admin screen rather than from here.
 *
 * The table below still matters. A retreat seeded before any of this existed
 * has no rows of its own, and an act key nobody has given a name to has to
 * render as something — so these five stay as the floor under it.
 */

export const ACTS = {
  PROLOGUE: {
    title: 'The quiet before the island',
    lede: 'Go inward before you set foot on the atoll.',
  },
  'ACT I': {
    title: 'Arrival',
    lede: 'The first day is a descent. Nothing has to happen at once.',
  },
  'ACT II': {
    title: 'Rhythm',
    lede: 'The same skeleton every day. What changes is you.',
  },
  'ACT III': {
    title: 'Closing',
    lede: 'What you carry home is decided in the last two days.',
  },
  EPILOGUE: {
    title: 'Ninety days',
    lede: 'The programme does not end with the island. The harder part starts there.',
  },
}

const UNNAMED = { title: 'Your path', lede: 'Day by day, in the order it comes.' }

/**
 * What this chapter is called.
 *
 * `fromRetreat` is the map the journey carries. It wins over the table above,
 * because somebody wrote it for this retreat on purpose; the table is what
 * answers when nobody has.
 *
 * @param {string|null|undefined} act
 * @param {Record<string, {title: string, lede: string|null}>} fromRetreat
 */
export function actCopy(act, fromRetreat = {}) {
  const written = act === null || act === undefined ? undefined : fromRetreat[act]

  if (written?.title) {
    return { title: written.title, lede: written.lede ?? ACTS[act]?.lede ?? UNNAMED.lede }
  }

  return ACTS[act] ?? UNNAMED
}
